import { Component } from '@angular/core';
import { CustomCellRenderer } from '../base-renderer/custom-renderer.base';

@Component({
  selector: 'app-username-renderer',
  templateUrl: './username-renderer.component.html'
})
export class UsernameRendererComponent extends CustomCellRenderer {}
